<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import LaisStaticMap from 'dashboard/components-next/LaisStaticMap.vue';
import { visitPropertyImage } from '../utils/visitDetailPresenter';
import {
  visitRequestFeedbackMessage,
  visitRequestFeedbackRows,
} from '../utils/visitSuccessUtils';

defineProps({
  visit: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['details']);

const REQUEST_FEEDBACK_COPY = Object.freeze({
  title: 'Sua visita foi solicitada',
  detailsTitle: 'Detalhes da visita solicitada',
  detailsButton: 'Ver detalhes da visita',
});
</script>

<template>
  <div class="grid gap-5">
    <LaisCard>
      <div class="grid gap-4 text-center">
        <span
          class="mx-auto grid size-14 place-items-center rounded-full border border-lais-primary/20 bg-lais-primary-50 text-lais-primary"
        >
          <span class="i-lucide-check size-7 text-current" aria-hidden="true" />
        </span>
        <div>
          <h1
            class="font-redHatDisplay text-[28px] font-semibold text-lais-text"
          >
            {{ REQUEST_FEEDBACK_COPY.title }}
          </h1>
          <p
            class="mx-auto mt-2 max-w-[560px] text-[14px] leading-6 text-lais-text-body"
          >
            {{ visitRequestFeedbackMessage }}
          </p>
        </div>
      </div>
    </LaisCard>

    <LaisCard :title="REQUEST_FEEDBACK_COPY.detailsTitle">
      <div class="grid gap-4">
        <LaisStaticMap
          v-if="visitPropertyImage(visit)"
          :src="visitPropertyImage(visit)"
          :alt="visit.imovel?.titulo || 'Imóvel da visita'"
          aspect-class="h-[220px]"
        />

        <div class="grid gap-4">
          <div
            v-for="row in visitRequestFeedbackRows(visit)"
            :key="row.label"
            class="flex gap-3 rounded-lais-sm border border-lais-border-soft bg-lais-bg-soft px-4 py-3"
          >
            <span
              class="mt-0.5 size-5 shrink-0 text-lais-primary"
              :class="row.icon"
              aria-hidden="true"
            />
            <div class="min-w-0">
              <p class="text-[12px] font-semibold text-lais-text-muted">
                {{ row.label }}
              </p>
              <p
                class="mt-1 text-[14px] font-semibold leading-snug text-lais-text [overflow-wrap:anywhere]"
              >
                {{ row.value }}
              </p>
            </div>
          </div>
        </div>

        <LaisPrimaryButton
          icon="i-lucide-list-checks"
          class="w-full justify-center"
          @click="emit('details')"
        >
          {{ REQUEST_FEEDBACK_COPY.detailsButton }}
        </LaisPrimaryButton>
      </div>
    </LaisCard>
  </div>
</template>
